import {inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {PaymentVerificationResult} from '@features/payment/domain/model/payment.model';
import {PaymentStrategy} from '@features/payment/domain/ports/strategy/payment-strategy.port';
import {Payment} from '@features/payment/domain/entities/payment.entity';
import {CheckoutGateway} from '../../gateways/checkout.gateway';
import {CheckoutPayloadMapper} from '../../mappers/checkout-payload.mapper';
import {PaymentPollingEngine} from '../../services/payment-polling.engine';
import {PaymentStatusTranslator} from '../../services/payment-status.translator';

@Injectable({providedIn: 'root'})
export class OnlineCloudStrategy implements PaymentStrategy {
  private readonly engine = inject(PaymentPollingEngine);
  private readonly checkoutGateway = inject(CheckoutGateway);
  private readonly mapper = inject(CheckoutPayloadMapper);
  private readonly translator = inject(PaymentStatusTranslator);

  checkout(payments: Payment[]): Observable<string> {
    const payload = this.mapper.toCheckoutPayload(payments);

    return this.checkoutGateway.checkoutOnline(payload);
  }

  verify(payment: Payment): Observable<PaymentVerificationResult> {
    if (!payment.transactionId) {
      throw new Error(`[OnlineCloudStrategy] Missing transactionId for verification`);
    }

    return this.engine.poll(payment.transactionId).pipe(
      map(status => this.translator.translate(status))
    );
  }
}
